/**
 * Auto-generated standalone warehouse data loader
 * DO NOT EDIT - generated from Scanner's dbo.Warehouses by npm run build
 *
 * Chain: dbo.Warehouses -> src/data/warehouseData.ts (build:warehouses) -> .tsbuild -> this file
 *
 * Populates window.warehouseData with PascalCase properties for backward compatibility
 */
(function () {
  "use strict";

  // Warehouse data converted from TypeScript source
  const WAREHOUSES = [
  {
    "Code": "A4CA",
    "Name": "A4, CA",
    "Vendor": "A4",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "90058",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "A4MO",
    "Name": "A4, MO",
    "Vendor": "A4",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "64083",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "AUWI",
    "Name": "Art Unlimited, WI",
    "Vendor": "AU",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "54902",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "AWDNC",
    "Name": "AWDis, NC",
    "Vendor": "AWD",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "29556",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "BGNJ",
    "Name": "Blue Generation, NJ",
    "Vendor": "BG",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "07055",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "BRHTX",
    "Name": "Blank Rope Hats, TX",
    "Vendor": "BRH",
    "RequiresCaseQuantity": true,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "78118",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "CHCA",
    "Name": "Cotton Heritage, CA",
    "Vendor": "CH",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 6,
    "SourceZipCode": "90040",
    "SortOrder": 6,
    "Enabled": false,
    "PickupAvailable": false
  },
  {
    "Code": "CHTX",
    "Name": "Cotton Heritage, TX",
    "Vendor": "CH",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "75019",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "CHVA",
    "Name": "Cotton Heritage, VA",
    "Vendor": "CH",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "24112",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "COBTX",
    "Name": "Cobra Caps, TX",
    "Vendor": "COB",
    "RequiresCaseQuantity": true,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "75238",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "CTFL",
    "Name": "ColorTone, FL",
    "Vendor": "CT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "33313",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "FOLAL",
    "Name": "Jerzee/FOTL, AL",
    "Vendor": "FOL",
    "RequiresCaseQuantity": true,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "35010",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "GNC",
    "Name": "Gildan, NC",
    "Vendor": "G",
    "RequiresCaseQuantity": true,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "27288",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "GTX",
    "Name": "Gildan Baytown, TX",
    "Vendor": "G",
    "RequiresCaseQuantity": true,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "27288",
    "SortOrder": 6,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "LATGA",
    "Name": "LAT Apparel, GA",
    "Vendor": "LAT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "30107",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "LATNV",
    "Name": "LAT Apparel, NV",
    "Vendor": "LAT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "89434",
    "SortOrder": 5,
    "Enabled": false,
    "PickupAvailable": false
  },
  {
    "Code": "LBCA",
    "Name": "Libery Bags, CA",
    "Vendor": "LB",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "91706",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "LBTX",
    "Name": "Liberty Bags, TX",
    "Vendor": "LB",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "75604",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "LSCA",
    "Name": "Lane Seven, CA",
    "Vendor": "LS",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 6,
    "SourceZipCode": "91706",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "LSNC",
    "Name": "Lane Seven, NC",
    "Vendor": "LS",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "28054",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "MMTNC",
    "Name": "Momentec, NC",
    "Vendor": "MMT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "28083",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "NLAL",
    "Name": "Next Level, AL",
    "Vendor": "NL",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "36303",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "NLCA",
    "Name": "Next Level, CA",
    "Vendor": "NL",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "90503",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "NONE",
    "Name": "No Fulfillment",
    "Vendor": "WP",
    "RequiresCaseQuantity": false,
    "CutoffTime": "23:59",
    "DefaultTransitDays": 0,
    "SourceZipCode": "70806",
    "SortOrder": 99,
    "Enabled": true,
    "PickupAvailable": true
  },
  {
    "Code": "OCAR",
    "Name": "Outdoor Cap",
    "Vendor": "OC",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "72712",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "OTHER",
    "Name": "Other Source",
    "Vendor": "WP",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "75244",
    "SortOrder": 4,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "PENNH",
    "Name": "Pennant, NH",
    "Vendor": "PEN",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "03060",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "PNC",
    "Name": "Paragon, NC",
    "Vendor": "P",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "28273",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "PRMO",
    "Name": "St Charles, MO",
    "Vendor": "PR",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "63304",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "QTCA",
    "Name": "QTees, CA",
    "Vendor": "QT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "90640",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "QTGA",
    "Name": "QTees, GA",
    "Vendor": "QT",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "30083",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "RNTX",
    "Name": "Reina Texas",
    "Vendor": "RN",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "78701",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SBCA",
    "Name": "Smart Blanks, CA",
    "Vendor": "SB",
    "RequiresCaseQuantity": false,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "92806",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SBTX",
    "Name": "Smart Blanks, TX",
    "Vendor": "SB",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "75050",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SHIL",
    "Name": "Stratton Hats, IL",
    "Vendor": "SH",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 4,
    "SourceZipCode": "60104",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SPTX",
    "Name": "Sierra Pacific, TX",
    "Vendor": "SP",
    "RequiresCaseQuantity": false,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "77478",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SSSC",
    "Name": "SoftShirts SC",
    "Vendor": "SS",
    "RequiresCaseQuantity": false,
    "CutoffTime": "12:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "29611",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SWCA",
    "Name": "Shaka Wear, CA",
    "Vendor": "SW",
    "RequiresCaseQuantity": true,
    "CutoffTime": "14:00",
    "DefaultTransitDays": 5,
    "SourceZipCode": "90001",
    "SortOrder": 5,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "SWTX",
    "Name": "Shaka Wear, TX",
    "Vendor": "SW",
    "RequiresCaseQuantity": true,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 3,
    "SourceZipCode": "77047",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "TEST",
    "Name": "TEST",
    "Vendor": "TEST",
    "RequiresCaseQuantity": false,
    "CutoffTime": "00:00",
    "DefaultTransitDays": 0,
    "SourceZipCode": "",
    "SortOrder": 0,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "WPBR",
    "Name": "WP, Baton Rouge",
    "Vendor": "WP",
    "RequiresCaseQuantity": false,
    "CutoffTime": "15:30",
    "DefaultTransitDays": 1,
    "SourceZipCode": "70806",
    "SortOrder": 1,
    "Enabled": true,
    "PickupAvailable": true
  },
  {
    "Code": "WPDS1",
    "Name": "Direct Ship A",
    "Vendor": "ST",
    "RequiresCaseQuantity": false,
    "CutoffTime": "15:00",
    "DefaultTransitDays": 1,
    "SourceZipCode": "38118",
    "SortOrder": 3,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "WPDS2",
    "Name": "Direct Ship B",
    "Vendor": "ST",
    "RequiresCaseQuantity": false,
    "CutoffTime": "15:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "75244",
    "SortOrder": 4,
    "Enabled": true,
    "PickupAvailable": false
  },
  {
    "Code": "WPMS",
    "Name": "Booneville MS WH",
    "Vendor": "WP",
    "RequiresCaseQuantity": true,
    "CutoffTime": "13:00",
    "DefaultTransitDays": 2,
    "SourceZipCode": "38118",
    "SortOrder": 2,
    "Enabled": true,
    "PickupAvailable": false
  }
];

  // Populate global variable
  window.warehouseData = WAREHOUSES;
  console.log(
    "Warehouse data loaded from standalone script:",
    window.warehouseData.length,
    "warehouses",
  );
})();
